import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill={props.color}
      d="m7.472 10.693.707.707c.155.162.371.251.595.246h.837v.708c0 .53.43.96.96.96h.708v.835c0 .22.087.432.241.589l.555.555a.783.783 0 0 0 .554.227h2.205a.69.69 0 0 0 .688-.688v-2.204a.78.78 0 0 0-.23-.557l-4.6-4.599A5.256 5.256 0 1 0 .51 6.322a5.26 5.26 0 0 0 6.963 4.37Zm-4.776-8a4.295 4.295 0 0 1 6.995 4.712.48.48 0 0 0 .103.526L14.56 12.7v1.861H12.7l-.47-.469v-1.13a.618.618 0 0 0-.618-.618H10.57l.001-1.04a.618.618 0 0 0-.617-.617h-1.13l-.893-.892a.48.48 0 0 0-.526-.103 4.298 4.298 0 0 1-5.932-3.386 4.297 4.297 0 0 1 1.221-3.609l.002-.004Zm2.01 3.775a1.761 1.761 0 1 0-.002-3.522 1.761 1.761 0 0 0 .001 3.522Zm0-2.548a.801.801 0 1 1-.001 1.606.801.801 0 0 1 0-1.608v.002Z"
    />
  </svg>
)
export default SvgComponent
